<style lang="less" scoped>
  .present-col {
    width: 50%;
    padding: 0 16px;
    float: left;
    margin-bottom: 20px;

    .present-cover {
      border-radius: 4px;
      border: 1px solid #d9dde8;

      .present-ceil {
        padding: 12px 16px;
        align-content: center;
        box-shadow: inset 0 -1px 0 0 #d9dde8;

        .present-ceil-row {
          display: flex;
          margin-bottom: 4px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .present-options {
          color: #8192a8;
        }

        .present-cnt {
          flex: 1;
          text-align: right;
          color: #9b9b9b;
        }
      }

      .present-content {
        padding: 16px;
        border-bottom: 1px solid #d9dde8;

        .present-list {
          margin-bottom: 8px;
          display: flex;
        }
          .present-content-title {
            color: #9b9b9b;
            font-weight: bold;
          }
          .present-unit {
            color: #9b9b9b;
            text-align: right;
            padding-right: 5px
          }
          .present-content-standard {
            flex: 1;
          }

        .present-list:last-child {
          margin-bottom: 0;
        }
      }

      .present-content:last-child {
        border-bottom: none;
      }
    }
  }

  &:after {
    content: "";
    display: block;
    clear: both;
  }

  @media screen and (max-width: 560px) {
    .present-col {
      width: 100%;
    }
  }
</style>

<template lang="pug">
  .present-col
    .present-cover
      .present-ceil
        .present-ceil-row
          strong {{prescription.name}}
          div.present-cnt {{prescription.units}}ea
        // .present-ceil-row.present-options
        //   div 주수상반(+5,000)
      .present-content
        .present-list(v-for="ingredient in prescription.ingredients")
          div {{ingredient.name}}
          div.present-unit.present-content-standard
            span &#x20A9; {{ingredient.price}}/g × {{ingredient.amount}}g =
          div &#x20A9 {{Math.round(ingredient.totalPrice * 100) / 100}}원
      .present-content
        .present-list
          div.present-content-title.present-content-standard 약재비
          div &#x20A9;{{prescription.priceDetail.chups.toLocaleString()}}
        .present-list
          div.present-content-title.present-content-standard 조제비
          div &#x20A9;{{(prescription.priceDetail.dispensing + prescription.priceDetail.packs).toLocaleString()}}
        .present-list
          div.present-content-title.present-content-standard 탕전비
          div &#x20A9;{{prescription.priceDetail.boiling.toLocaleString()}}
</template>

<script>
import happytree from '@/happytree';

export default {
  props: ['prescription'],
  computed: {
    pricePerUnit() {
      let result = 0;
      this.prescription.ingredients.forEach((element) => {
        const price = element.price;
        const amount = element.amount;
        result += price * amount;
      });
      return result;
    },
    medicinePrice() {
      let result = 0;
      const morePacks = (this.prescription.packs - 30) < 0 ? 0 : this.prescription.packs - 30;
      result += (this.pricePerUnit * this.prescription.units); // 첩당 가격 * 첩 수
      result += 17000; // 기본료
      result += morePacks * 150; // 30팩 이후 가격 150원씩 추가
      return result;
    },
  },
  filters: {
    price(value) {
      if (typeof value === 'number') {
        return value.toLocaleString();
      }
      return value;
    },
  },
  data() {
    return {
      deliveryPrice: null,
    };
  },
  mounted() {
    const deliveryPrice = this.prescription === happytree.delivery.basic ? 4000 : 5000;
    const packs = this.prescription.packs;
    this.deliveryPrice = (Math.floor(packs / 45) + ((packs % 45 > 0) ? 1 : 0)) * deliveryPrice;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/present_card.vue